
import { Component, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { DataTableHeader } from 'vuetify';
import TicketRepositoryInterface, {
  CronFilterInterface,
  TicketFiltersInterface,
} from '@/services/QC-V2/ticket/interfaces';
import DeleteFilterDialog from '@/components/dialogs/qc-v2/ticket/cron/DeleteFilterDialog.vue';

@Component({
  mixins: [
    Themeable,
  ],
  inject: [
    'ticketRepositoryV2',
  ],
  components: {
    DeleteFilterDialog,
  },
})
export default class CronConfig extends Vue {
  private ticketRepositoryV2!: TicketRepositoryInterface;
  private settings: CronFilterInterface[] = [];
  private loading: boolean = true;
  private search: string = '';
  private deleteFilterForDialog: CronFilterInterface | false = false;
  private deleteFilterDialog: string = '';

  private ticketFiltersMap: TicketFiltersInterface = {
    name: 'Client Name',
    email: 'Client Email',
    status: 'Ticket Status',
    department: 'Department',
    client_id: 'Client ID',
  };

  private headers: DataTableHeader[] = [
    { text: 'ID', value: 'id' },
    { text: 'Property', value: 'property' },
    { text: 'Value', value: 'value' },
    { text: 'Actions', value: 'actions', sortable: false },
  ];

  private async created(): Promise<void> {
    await this.initialize();
  }

  private async initialize(): Promise<void> {
    this.settings = await this.ticketRepositoryV2.getCronFilters();
    this.loading = false;
  }

  private async createSettings(): Promise<void> {
    await this.$router.push({ name: 'create_ticket_cron_config' });
  }

  private async editFilter(id: number): Promise<void> {
    await this.$router.push({ name: 'update_ticket_cron_config', params: { id: String(id) } });
  }

  private async deleteFilter(filter: CronFilterInterface): Promise<void> {
    this.deleteFilterDialog = 'delete-filter-dialog';
    this.deleteFilterForDialog = filter;
  }
}
